// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__fTy+c","img":"Search_img__W78UJ","text":"Search_text__1YcXQ"};